export default "__VITE_ASSET__Cq$UdHUZ__"